import React from "react";
import EXCenterMenuProvider from "./EXCenterMenuProvider";

export const EXCenterNavTopBar = () => {
    return <EXCenterMenuProvider className="wb-bs-visible-only" mode="horizontal" withMore={true} />;
};
